// @flow
import React, { Fragment } from "react";
import Button from "../Button";
import styled from "styled-components";
import { post, normalPost } from "../../lib/Fetching";
import PrintSampleBarcodes from "./PrintSampleBarcodes";
import CaveatPicker from "../sample_testing/CaveatPicker";
import CommentPicker from "../registration/CommentPicker";
import TodoPicker from "../registration/TodoPicker";

const Container = styled.div`
  padding-top: 10px;
  padding-bottom: 10px;
`;

type Props = {
  sampleIds: Array<number>,
  receivingBranchId: number,
  onChange: Function,
};

export default class ReceivingToolbar extends React.Component<Props> {
  static defaultProps = {
    sampleIds: [],
  };

  constructor(props) {
    super(props);
    this.state = {
      pickCaveats: false,
      pickComments: false,
      pickTodos: false,
    };
  }

  canEdit = () => this.props.sampleIds.length > 0;

  sendSamples = () => {
    this._changeReceiveStatus("/sample_reception/receipts/send_many");
  };

  unSendSamples = () => {
    this._changeReceiveStatus("/sample_reception/receipts/unsend_many");
  };

  receiveSamples = () => {
    const { sampleIds } = this.props;
    if (
      !window.confirm(
        "Are you sure you want to RECEIVE " + sampleIds.length + " samples all at once?"
      )
    ) {
      return;
    }
    this._changeReceiveStatus("/sample_reception/receipts/receive_many");
  };

  unReceiveSamples = () => {
    const { sampleIds } = this.props;
    if (
      !window.confirm(
        "Are you sure you want to UN-RECEIVE " + sampleIds.length + " samples all at once?"
      )
    ) {
      return;
    }
    this._changeReceiveStatus("/sample_reception/receipts/unreceive_many");
  };

  pickSampleCaveats = () => {
    this.setState({ pickCaveats: !this.state.pickCaveats });
  };

  pickComments = () => {
    this.setState({ pickComments: !this.state.pickComments });
  };

  pickTodos = () => {
    this.setState({ pickTodos: !this.state.pickTodos });
  };

  _changeReceiveStatus = (url: string) => {
    const { sampleIds, receivingBranchId, onChange } = this.props;
    post(url, {
      sample_ids: sampleIds,
      company_branch_id: receivingBranchId,
    })
      .then((json) => {
        if (json.errors) {
          alert(json.errors);
        } else {
          onChange();
        }
      })
      .catch((errors) => alert(errors));
  };

  _baseUrl = () => {
    return window.location.protocol + "//" + window.location.host;
  };

  render() {
    const { sampleIds, onChange } = this.props;
    const { pickCaveats, pickComments, pickTodos } = this.state;
    const disabled = !this.canEdit();
    return (
      <Container>
        <Button tiny title="Un Receive" disabled={disabled} onClick={this.unReceiveSamples} />
        &nbsp;
        <Button tiny title="Receive" disabled={disabled} onClick={this.receiveSamples} />
        &nbsp;
        <Button tiny title="Mark As Sent" disabled={disabled} onClick={this.sendSamples} />
        &nbsp;
        <Button
          tiny
          title="Remove Sent Status"
          disabled={disabled}
          onClick={this.unSendSamples}
        />
        &nbsp;
        <PrintSampleBarcodes
          sample_ids={sampleIds}
          disabled={disabled}
          printAliquotBarcodes={false}
        />
        &nbsp;
        <Button
          tiny
          title={"Add Sample Caveats"}
          disabled={disabled}
          onClick={this.pickSampleCaveats}
        />
        &nbsp;
        <Button
          tiny
          title={"Add Comment"}
          disabled={disabled}
          onClick={this.pickComments}
        />
        &nbsp;
        <Button
          tiny
          title={"Add Todo"}
          disabled={disabled}
          onClick={this.pickTodos}
        />
        {pickCaveats && (
          <div style={{ margin: 40, maxWidth: 1200 }}>
            <CaveatPicker type="sample" ids={sampleIds} onApply={onChange} />
          </div>
        )}
        {pickComments && (
          <div style={{ margin: 40, maxWidth: 1200 }}>
            <CommentPicker ids={sampleIds} onApply={onChange} clientView={false} />
          </div>
        )}
        {pickTodos && (
          <div style={{ margin: 40, maxWidth: 1200 }}>
            <TodoPicker ids={sampleIds} onApply={onChange} clientView={false} />
          </div>
        )}
      </Container>
    );
  }
}
